import { GRAPH_MODE } from "../common/constants";

let diagramParamsInitial = {
    id: [],
    // level
    level: 1,
    // historicalRelations
    history: false,
    dateFrom: new Date(2000, 0, 1),
    dateTo: new Date(),
    // relationDirections
    direction: 0,
    // ownershipInterest
    shareChecked: false,
    sharePct: 50,
    // relationTypes
    rt: [],
    // warningTypes
    wt: [],
    // MM TODO ?
    ln: []
};

let diagram = {
    nodeDiagram: undefined,
    diagramParams: { ...diagramParamsInitial },
    selectedNodes: [],

    nodeMagnifier: undefined,
    userScaleInput: undefined,

    _mode: GRAPH_MODE.default,
    _initParams: null,
    _rootIdList: [],
    _nodes: undefined,
    _relations: undefined,
    _relationsOriented: undefined,

    _noGraphZoom: undefined,
    _recalculateRelationsCounts: false,
    _marginCorrection: false,
    _noConflictGoBtnClick: undefined,
    _noConflictGoBtnTooltip: undefined,
    _noConflictGoBtnReleaseAfterExec: undefined,

    _showCustomEntityPopupFunc: null,
    _showCustomRelationPopupFunc: null,
    _showCustomSearchPopupFunc: null,
    _addToClipboardFunc: null,
    _removeFromClipboardFunc: null,
    _showInformationMessagePopupFunc: null,
    _showWarningMessagePopupFunc: null,
    _showRelationUnlimitedPopup: null,

    _currentUser: null,
}

const initialState = {
    sizeChanged: false,
    scrolledTo: false,
    domainsInitialized: false,
    loading: false,
    nodeCount: 0,
    mode: GRAPH_MODE.default,
    legendData: {
        warnings: [],
        supplementary: []
    },
    domains: {
        relationTypes: [],
        warningTypes: [],
        supplementary: undefined
    },
}

export { diagram, initialState as diagramInitialState, diagramParamsInitial };
